import {typography} from 'material-ui/styles';
//import {grey600} from 'material-ui/styles/colors';

const styles = {
  navigation: {
    fontSize: 15,
    fontWeight: typography.fontWeightLight,
    color: '#636363',
    paddingBottom: 15,
    display: 'block'
  },
  cardHeader: {
    padding: 8,
    border: '1px solid #f5aa00',
    fontWeight: 500,
    color: '#505050'
  }
};

export default styles;



/** WEBPACK FOOTER **
 ** ./src/styles.js
 **/